import { createFileRoute, redirect } from "@tanstack/react-router"

import { SettingsLayout } from "@/components/layout/settings-layout"

export const Route = createFileRoute("/_authenticated/settings")({
  // Default settings URL: send bare /settings to Account so the layout always has a child route.
  beforeLoad: ({ location }) => {
    const p = location.pathname.replace(/\/$/, "")
    if (p === "/settings") {
      throw redirect({ to: "/settings/account/profile" })
    }
  },
  component: SettingsLayout,
})
